<template>
  <el-form ref="form" :model="form" label-position="top">
    <!-- 认证法规 -->
    <div class="form_container">
      <el-form-item label="基本政策" prop="certificationRegulations">
        <el-input
          v-model="form.certificationRegulations"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="最新动态" prop="certificationRegulationsDynamic">
        <el-input
          v-model="form.certificationRegulationsDynamic"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </div>
    <!-- 全环节税收政策 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        全环节税收政策
      </div>
    </div>
    <div class="form_container">
      <el-form-item label="基本政策" prop="taxStrategy">
        <el-input
          v-model="form.taxStrategy"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="最新动态" prop="taxStrategyDynamic">
        <el-input
          v-model="form.taxStrategyDynamic"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </div>
    <!-- 补贴/罚款政策 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        补贴/罚款政策
      </div>
    </div>
    <div class="form_container">
      <el-form-item label="基本政策" prop="subsidiesFines">
        <el-input
          v-model="form.subsidiesFines"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="最新动态" prop="subsidiesFinesDynamic">
        <el-input
          v-model="form.subsidiesFinesDynamic"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </div>
    <!-- 鼓励性/限制性汽车政策/充电桩建设 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        鼓励性/限制性汽车政策/充电桩建设
      </div>
    </div>
    <div class="form_container">
      <el-form-item label="基本政策" prop="incentiveRestrictive">
        <el-input
          v-model="form.incentiveRestrictive"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="最新动态" prop="incentiveRestrictiveDynamic">
        <el-input
          v-model="form.incentiveRestrictiveDynamic"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </div>
    <!-- 主要汽车品牌以及中国汽车品牌的生产销售模式 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        主要汽车品牌以及中国汽车品牌的生产销售模式
      </div>
    </div>
    <div class="table_container">
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="tableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ borderColor: '#dcdfe6' }"
        :cell-class-name="cellClassName"
        @cell-click="handleCellClick"
      >
        <!-- 序号 -->
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <!-- 汽车品牌 -->
        <el-table-column
          prop="carBrand"
          label="汽车品牌"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'carBrand' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.carBrand"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.carBrand }}
            </div>
          </template>
        </el-table-column>
        <!-- 合作伙伴 -->
        <el-table-column
          prop="partnershipPartner"
          label="合作伙伴"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'partnershipPartner' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.partnershipPartner"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.partnershipPartner }}
            </div>
          </template>
        </el-table-column>
        <!-- 合作伙伴性质 -->
        <el-table-column
          prop="partnershipPartnerNature"
          label="合作伙伴性质"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-if="
                editField === 'partnershipPartnerNature' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.partnershipPartnerNature"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
              automatic-dropdown
              @visible-change="visibleChange"
              @change="confirmEdit"
            >
              <el-option label="国营" value="国营"></el-option>
              <el-option label="私营" value="私营"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.partnershipPartnerNature }}
            </div>
          </template>
        </el-table-column>
        <!-- 合作模式 -->
        <el-table-column
          prop="cooperationModel"
          label="合作模式"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'cooperationModel' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.cooperationModel"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.cooperationModel }}
            </div>
          </template>
        </el-table-column>
        <!-- 生产供应模式 -->
        <el-table-column
          prop="productionSupplyMode"
          label="生产供应模式"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-if="
                editField === 'productionSupplyMode' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.productionSupplyMode"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
              automatic-dropdown
              @visible-change="visibleChange"
              @change="confirmEdit"
            >
              <el-option label="CBU" value="CBU"></el-option>
              <el-option label="SKD" value="SKD"></el-option>
              <el-option label="CKD" value="CKD"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.productionSupplyMode }}
            </div>
          </template>
        </el-table-column>
        <!-- 销售模式 -->
        <el-table-column
          prop="saleMode"
          label="销售模式"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-if="editField === 'saleMode' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.saleMode"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
              automatic-dropdown
              @visible-change="visibleChange"
              @change="confirmEdit"
            >
              <el-option label="直营" value="直营"></el-option>
              <el-option label="分销" value="分销"></el-option>
              <el-option label="混合" value="混合"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.saleMode }}
            </div>
          </template>
        </el-table-column>
        <!-- 三级毛利水平 (%) -->
        <el-table-column label="三级毛利水平 (%)" align="center">
          <!-- KD -->
          <el-table-column prop="kd" label="KD" min-width="90px" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="editField === 'kd' && editIndex === scope.$index"
                id="focusRef"
                v-model="scope.row.kd"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              ></el-input>
              <div v-else>
                {{ scope.row.kd }}
              </div>
            </template>
          </el-table-column>
          <!-- 总代 -->
          <el-table-column
            prop="totalGeneration"
            label="总代"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input
                v-if="
                  editField === 'totalGeneration' && editIndex === scope.$index
                "
                id="focusRef"
                v-model="scope.row.totalGeneration"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              ></el-input>
              <div v-else>
                {{ scope.row.totalGeneration }}
              </div>
            </template>
          </el-table-column>
          <!-- 终端 -->
          <el-table-column
            prop="terminal"
            label="终端"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input
                v-if="editField === 'terminal' && editIndex === scope.$index"
                id="focusRef"
                v-model="scope.row.terminal"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              ></el-input>
              <div v-else>
                {{ scope.row.terminal }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <!-- 备注 -->
        <el-table-column
          prop="remark"
          label="备注"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'remark' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.remark"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.remark }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 汽车消费金融环境变化 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        汽车消费金融环境变化
      </div>
    </div>
    <div class="table_container">
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="tableData2"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-style="{ borderColor: '#dcdfe6' }"
        :cell-class-name="cellClassName"
        @cell-click="handleCellClick2"
      >
        <!-- 序号 -->
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <!-- 金融服务名称/提供商 -->
        <el-table-column
          prop="name"
          label="金融服务名称/提供商"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField2 === 'name' && editIndex2 === scope.$index"
              id="focusRef"
              v-model="scope.row.name"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <!-- 首付比例 -->
        <el-table-column
          prop="downPaymentRatio"
          label="首付比例"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField2 === 'downPaymentRatio' && editIndex2 === scope.$index
              "
              id="focusRef"
              v-model="scope.row.downPaymentRatio"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.downPaymentRatio }}
            </div>
          </template>
        </el-table-column>
        <!-- 贷款利率 -->
        <el-table-column
          prop="loanInterestRate"
          label="贷款利率"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField2 === 'loanInterestRate' && editIndex2 === scope.$index
              "
              id="focusRef"
              v-model="scope.row.loanInterestRate"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.loanInterestRate }}
            </div>
          </template>
        </el-table-column>
        <!-- 最长贷款周期 -->
        <el-table-column
          prop="longestLoanCycle"
          label="最长贷款周期"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField2 === 'longestLoanCycle' && editIndex2 === scope.$index
              "
              id="focusRef"
              v-model="scope.row.longestLoanCycle"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.longestLoanCycle }}
            </div>
          </template>
        </el-table-column>
        <!-- 审批通过率 -->
        <el-table-column
          prop="approvalPassRate"
          label="审批通过率"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField2 === 'approvalPassRate' && editIndex2 === scope.$index
              "
              id="focusRef"
              v-model="scope.row.approvalPassRate"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.approvalPassRate }}
            </div>
          </template>
        </el-table-column>
        <!-- 有无限制/担保条件/保险条件 -->
        <el-table-column
          prop="conditionRestrictions"
          label="有无限制/担保条件/保险条件"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-if="
                editField2 === 'conditionRestrictions' &&
                  editIndex2 === scope.$index
              "
              id="focusRef"
              v-model="scope.row.conditionRestrictions"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
              automatic-dropdown
              @visible-change="visibleChange"
              @change="confirmEdit"
            >
              <el-option label="有" value="有"></el-option>
              <el-option label="无" value="无"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.conditionRestrictions }}
            </div>
          </template>
        </el-table-column>
        <!-- 限制/担保/保险条件说明 -->
        <el-table-column
          prop="conditionRestrictionsRemark"
          label="限制/担保/保险条件说明"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField2 === 'conditionRestrictionsRemark' &&
                  editIndex2 === scope.$index
              "
              id="focusRef"
              v-model="scope.row.conditionRestrictionsRemark"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.conditionRestrictionsRemark }}
            </div>
          </template>
        </el-table-column>
        <!-- 备注 -->
        <el-table-column
          prop="remark"
          label="备注"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField2 === 'remark' && editIndex2 === scope.$index"
              id="focusRef"
              v-model="scope.row.remark"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.remark }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-form>
</template>

<script>
import { addOrUpdateIndustryInfoApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      form: this.getForm(),
      tableData: [],
      tableData2: [],
      editField: "", // 编辑单元格
      editIndex: -1, // 编辑行索引
      editField2: "", // 编辑单元格2
      editIndex2: -1 // 编辑行索引2
    };
  },
  methods: {
    init(
      data = {
        saleIndustryPolicyDynamic: {},
        saleProductionBrandList: [],
        saleCarFinanceList: []
      },
      queryParams = {}
    ) {
      this.form = this.getForm(data.saleIndustryPolicyDynamic || {});
      this.tableData = data.saleProductionBrandList || [];
      this.tableData2 = data.saleCarFinanceList || [];
      this.queryParams = { ...queryParams };
    },
    // 获取表单数据
    getForm(data = {}) {
      return {
        id: data.id || "",
        certificationRegulations: data.certificationRegulations || "", // 认证法规
        certificationRegulationsDynamic:
          data.certificationRegulationsDynamic || "", // 认证法规动态
        taxStrategy: data.taxStrategy || "", // 全环节税收政策
        taxStrategyDynamic: data.taxStrategyDynamic || "", // 全环节税收政策动态
        subsidiesFines: data.subsidiesFines || "", // 补贴/罚款政策
        subsidiesFinesDynamic: data.subsidiesFinesDynamic || "", // 补贴/罚款政策动态
        incentiveRestrictive: data.incentiveRestrictive || "", // 鼓励性/限制性汽车政策/充电桩建设
        incentiveRestrictiveDynamic: data.incentiveRestrictiveDynamic || "" // 鼓励性/限制性汽车政策/充电桩建设动态
      };
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格2
    handleCellClick2(row, column) {
      this.handleColumn2(column.property, row.index ?? -1);
      this.tableData2[row.index][column.property] =
        this.tableData2[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 点击单元格编辑2
    handleColumn2(field, index) {
      this.editField2 = field;
      this.editIndex2 = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
      this.editField2 = "";
      this.editIndex2 = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          data: {
            saleIndustryPolicyDynamic: this.form,
            saleProductionBrandList: this.tableData,
            saleCarFinanceList: this.tableData2
          }
        };
        const res = await addOrUpdateIndustryInfoApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data.saleProductionBrandList;
          this.tableData2 = res.data.saleCarFinanceList;
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.hearder_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #333333;
  padding: 14px 10px 14px 20px;
  border-bottom: 1px solid #dcdee0;
  .title_icon {
    margin-right: 10px;
  }
  p {
    font-size: 16px;
    color: #4095e5;
    font-weight: bold;
    i {
      font-size: 18px;
      color: #4095e5;
      display: inline-block;
      margin-right: 5px;
    }
  }
}
.second_title {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #1890ff;
  padding: 22px 10px 10px 62px;
  border-bottom: 1px solid #dcdee0;
}
.third_title {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #1890ff;
  padding: 10px 10px 10px 62px;
}
.form_container {
  margin-top: 34px;
  padding: 0 18px 0 50px;
  ::v-deep {
    .el-input {
      width: 200px;
    }
  }
  .input_number_box {
    width: 200px;
  }
  .number_input {
    ::v-deep {
      .el-input__inner {
        text-align: left;
        border-radius: 4px 0 0 4px;
      }
      .el-input {
        width: 100%;
      }
    }
  }
  .number_input_append {
    color: #666666;
    background: #efefef;
    border-radius: 0 4px 4px 0;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    text-align: center;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    border: 1px solid #dcdfe6;
    border-left: none;
    box-sizing: border-box;
  }
}
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
